"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRtFilterOptions = void 0;
var SelectFilter_1 = require("./SelectFilter");
function createRtFilterOptions(filterOptions) {
    return {
        defaultCanFilter: true,
        filter: getOnFilter(filterOptions)
    };
}
exports.createRtFilterOptions = createRtFilterOptions;
function getOnFilter(filterOptions) {
    if ((filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.type) === undefined || filterOptions.type === 'select') {
        return SelectFilter_1.onSelectFilter;
    }
    return SelectFilter_1.onSelectFilter;
}
//# sourceMappingURL=options.js.map